// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.goodwe-monitoring-container {
    font-family: Arial, sans-serif;
    color: #333;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-width: 800px;
    margin: auto;
  }
  
  .alert-warning {
    background-color: #fff3cd;
    border: 1px solid #ffeeba;
    padding: 10px;
    margin-bottom: 20px;
    color: #856404;
    border-radius: 5px;
  }
  
  .installation-details {
    text-align: left;
    margin-bottom: 20px;
  }
  
  .installation-details div {
    font-size: 1em;
    margin: 5px 0;
  }
  
  .chart-container {
    margin: 20px auto;
    width: 90%;
    max-width: 800px;
    background-color: white;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  .strong {
    font-weight: bold;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/pagesInterfaces/Goodwe.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":[".goodwe-monitoring-container {\n    font-family: Arial, sans-serif;\n    color: #333;\n    padding: 20px;\n    background-color: #f5f5f5;\n    border-radius: 8px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    max-width: 800px;\n    margin: auto;\n  }\n  \n  .alert-warning {\n    background-color: #fff3cd;\n    border: 1px solid #ffeeba;\n    padding: 10px;\n    margin-bottom: 20px;\n    color: #856404;\n    border-radius: 5px;\n  }\n  \n  .installation-details {\n    text-align: left;\n    margin-bottom: 20px;\n  }\n  \n  .installation-details div {\n    font-size: 1em;\n    margin: 5px 0;\n  }\n  \n  .chart-container {\n    margin: 20px auto;\n    width: 90%;\n    max-width: 800px;\n    background-color: white;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  .strong {\n    font-weight: bold;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
